<mbs-modal
  [title]="baseModal.data.title"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  [showCloseCross]="false"
  [size]="MbsSize.sm"
  #modal>
  <div modal-body>
    <mbs-recovery-code
      [codes]="baseModal.data.codes"
      [isLogin]="false"
      [isResetCodes]="true"></mbs-recovery-code>
  </div>

  <ng-container modalFooter>
    <div class="d-flex justify-content-between w-100">
      <mbs-checkbox
        [(ngModel)]="isSavedRecoveryCodes"
        label="{{ 'shared:tfa.recoveryCode.savedCheckbox' | i18next }}"></mbs-checkbox>
      <mbs-button
        type="secondary"
        [type]="'primary'"
        [disabled]="!isSavedRecoveryCodes"
        data-dismiss="modal"
        (click)="modal.save()">
        {{ 'shared:tfa.finish' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>
  </ng-container>
</mbs-modal>
